const convert = (val) => {
  const arrOfNum = [];
  const answer = val.split(",");
  answer.forEach((str) => {
    arrOfNum.push(Number(str));
  });
  return arrOfNum;
};

export default convert;
